import { render, staticRenderFns } from "./ShareRewardConfig.vue?vue&type=template&id=367484be&scoped=true"
import script from "./ShareRewardConfig.vue?vue&type=script&lang=js"
export * from "./ShareRewardConfig.vue?vue&type=script&lang=js"
import style0 from "./ShareRewardConfig.vue?vue&type=style&index=0&id=367484be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367484be",
  null
  
)

export default component.exports